import { ExportRow } from '@portal/shared/types/export.types';
import { MissingProgrammingRecordsListItem } from '../missing-programming-records.types';

export const mapMissingProgrammingRecordToExport = (item: MissingProgrammingRecordsListItem): ExportRow => ({
  commDeviceId: { title: 'CommDeviceID', value: item.commDeviceId },
  initialTransmissionTime: { title: 'InitialTransmissionTime', value: item.initialTransmissionTime },
  lastTransmissionTime: { title: 'LastTransmissionTime', value: item.lastTransmissionTime }
});
